import { sub, mul } from "./vec3";

// Clip at the terrain before projection: one buried vertex must not discard
// a whole wall. Generated Float32 meshes can also put base vertices just below it.
export function groundShadowPolygon(vertices, sun, slopeDir, slopeGrad) {
  const a = slopeDir ? -slopeGrad * slopeDir.x : 0;
  const b = slopeDir ? -slopeGrad * slopeDir.y : 0;
  const beam = sun.z - a * sun.x - b * sun.y;
  if (beam <= 1e-6) return [];
  const height = p => p.z - a * p.x - b * p.y;
  const points = vertices.map(p => Math.abs(height(p)) < 1e-5
    ? { ...p, z: a * p.x + b * p.y } : p);
  const clipped = [];
  points.forEach((p, i) => {
    const q = points[(i + points.length - 1) % points.length];
    const hp = height(p), hq = height(q);
    if ((hp >= 0) !== (hq >= 0)) {
      const f = hq / (hq - hp);
      clipped.push({ x: q.x + f * (p.x - q.x), y: q.y + f * (p.y - q.y), z: q.z + f * (p.z - q.z) });
    }
    if (hp >= 0) clipped.push(p);
  });
  return clipped.map(p => sub(p, mul(sun, height(p) / beam)));
}
